import { ApolloCache } from 'apollo-cache';
import { AthleteOptions } from '../../components/Strava/types';
import { DemoAthleteQuery } from './queries';
import { updateAthleteOptions } from './services';

/** Local resolvers for the demo athlete settings */
export const resolvers = {
    Mutation: {
        demoAthleteOptions: (
            _: any,
            { input }: { input: AthleteOptions },
            { cache }: { cache: ApolloCache<any> }
        ) => updateAthleteOptions(input, cache)
    },
    Query: {
        demoAthlete: (
            _: any,
            args: any,
            { cache }: { cache: ApolloCache<any> }
        ) => {
            const data = cache.readQuery<{ demoAthlete: any }>({
                query: DemoAthleteQuery
            });
            return { demoAthlete: data ? data.demoAthlete : undefined };
        }
    }
};



// WEBPACK FOOTER //
// ./src/client/clientState/demoAthlete/resolvers.ts